//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import {
  parseDateYYYYMMDD,
  formatDateDDMMYYYY,
} from '../../common/functions/date-utils';
import InputDatepicker from '../../shared-components/datepicker/InputDatepicker';
import Confirm from '../../shared-components/vuetify/dialog/Confirm';

export default {
  name: 'AnoFiscalPeriodosOrçamento',
  props: {
    periodos: {
      type: Array,
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    dataInicio: {
      type: String,
      default: null,
    },
  },
  components: {
    InputDatepicker,
    Confirm,
  },
  data() {
    return {
      periodosSelecionados: [],
      menuDataInicio: false,
      menuDataFim: false,
      formatoSalvar: 'YYYY-MM-DD',
      dataInicioPeriodo: this.dataInicio,
      periodo: {
        descricao: null,
        dataInicio: '',
        dataFim: '',
      },
      igualAoPlanejamento: false,
      dialog: {
        content: '',
      },
      headers: [
        { text: this.$t('label.descricao'), value: 'descricao', sortable: false },
        { text: this.$t('label.data_inicio'), value: 'dataInicio', sortable: false },
        { text: this.$t('label.data_fim'), value: 'dataFim', sortable: false },
      ],
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        validDate: value => (!value || (value.length === 10 && this.moment(value, 'DD-MM-YYYY').isValid())) || this.$t('message.data_invalida'),
      },
    };
  },
  watch: {
    dataInicio(valor) {
      this.dataInicioPeriodo = valor;
    },
  },
  methods: {
    formatDateDDMMYYYY,
    validar() {
      if (this.periodos.length === 0) {
        this.$toast.create(this.$t('errors.meta.intervalos.obrigatorios'), 'snack', 3E3);
        return false;
      }
      return true;
    },
    getPeriodos() {
      const periodosSalvar = [];
      this.periodos.forEach((el) => {
        periodosSalvar.push(this.prepararPeriodoSalvar(el));
      });
      return periodosSalvar;
    },
    possuiPeriodos() {
      return this.periodos && this.periodos.length > 0;
    },
    limparForm() {
      this.$refs.descricaoAnoPeriodo.reset();
      this.$refs.anoPeriodoDataInicio.reset();
      this.$refs.anoPeriodoDataFim.reset();
    },
    changeIgualPlanejamento() {
      if (this.igualAoPlanejamento) {
        this.dialog.content = this.$t('message.advertencia_periodos_iguais');
        this.$refs.confirmDialog.open();
      } else {
        this.$emit('SINCRONIZACAO_PERIODOS', false);
      }
    },
    tratarPeriodosIguais() {
      this.$emit('SINCRONIZACAO_PERIODOS', true);
    },
    reverterOpcao() {
      this.igualAoPlanejamento = !this.igualAoPlanejamento;
    },
    prepararPeriodoSalvar(periodo) {
      const periodoSalvar = {};
      periodoSalvar.descricao = periodo.descricao;
      periodoSalvar.dataFim = this.alterarFormatoSalvar(periodo.dataFim);
      periodoSalvar.dataInicio = this.alterarFormatoSalvar(periodo.dataInicio);
      periodoSalvar.tipo = 'PLANEJAMENTO_ORCAMENTARIO';

      return periodoSalvar;
    },
    incluirPeriodo() {
      let valid = this.$refs.descricaoAnoPeriodo.validate(true);
      valid = this.$refs.anoPeriodoDataFim.validate(true) && valid;
      if (valid) {
        if (!this.periodos.length) {
          this.periodo.dataInicio = this.dataInicio;
        }
        this.periodos.push({
          descricao: this.periodo.descricao,
          dataInicio: this.periodo.dataInicio,
          dataFim: this.periodo.dataFim,
        });

        this.limparPeriodo();
        this.arrumarLista();
        this.emitirNotificacaoAlteracao();
      }
    },
    emitirNotificacaoAlteracao() {
      if (this.periodos.length) {
        this.$emit('PERIODO_INCLUIDO_OU_EXCLUIDO', this.periodos[this.periodos.length - 1].dataFim);
      } else {
        this.$emit('PERIODO_INCLUIDO_OU_EXCLUIDO', null);
      }
    },
    alterarFormatoSalvar(data) {
      return moment(data, this.formatoSalvar).format(this.formatoSalvar);
    },
    isAfter(data, outra) {
      return moment(data, this.formatoSalvar).isAfter(moment(outra, this.formatoSalvar));
    },
    arrumarLista() {
      this.periodos.sort((a, b) => this.isAfter(a.dataFim, b.dataFim));
    },
    limparPeriodo() {
      this.periodo.descricao = '';
      this.periodo.dataInicio = '';
      this.periodo.dataFim = '';
      this.limparForm();
    },
    preencherSelecionado(index) {
      const periodo = this.periodos[index];
      if (periodo) {
        periodo.index = index;
        this.periodosSelecionados.push(periodo);
      }
    },
    remover() {
      const index = [];
      this.periodosSelecionados.forEach((el) => {
        this.periodos.forEach((p, i) => {
          if (p.dataInicio === el.dataInicio &&
              p.dataFim === el.dataFim &&
              p.descricao === el.descricao) {
            index.push(i);
          }
        });
      });

      index.forEach(el => this.periodos.splice(el, 1));
      this.periodosSelecionados = [];
      this.arrumarLista();
      this.emitirNotificacaoAlteracao();
    },
  },
  computed: {
    dataInicioFormatada: {
      get() {
        return formatDateDDMMYYYY(this.periodo.dataInicio);
      },
      set(newValue) {
        this.periodo.dataInicio = parseDateYYYYMMDD(newValue);
      },
    },
    dataInicioPicker: {
      get() {
        return this.periodo.dataInicio ? this.periodo.dataInicio : this.dataInicio;
      },
      set(newValue) {
        this.periodo.dataInicio = newValue;
        if (this.isAfter(this.periodo.dataInicio, this.periodo.dataFim)) {
          this.periodo.dataFim = '';
        }
      },
    },
    dataFimFormatada: {
      get() {
        return formatDateDDMMYYYY(this.periodo.dataFim);
      },
      set(newValue) {
        this.periodo.dataFim = parseDateYYYYMMDD(newValue);
      },
    },
    dataFimPicker: {
      get() {
        return this.periodo.dataFim ? this.periodo.dataFim : this.periodo.dataInicio;
      },
      set(newValue) {
        this.periodo.dataFim = newValue;
      },
    },
    isContentAvailable() {
      return this.periodos.length > 0;
    },
    hojeYYYYMMD() {
      return [moment().format('YYYY-MM-D')];
    },
    hasPeriodosSelecionados() {
      return this.periodosSelecionados.length;
    },
  },
};



// WEBPACK FOOTER //
// ./src/spa/ano-fiscal/AnoFiscalPeriodosOrcamento.vue?vue&type=script&lang=js&